import http from '../../core/services/http'

export const generateMenuPublicationAgeReport = ({
  startDate,
  endDate,
  menuType,
}) => {
  const params = new URLSearchParams({ startDate, endDate, menuType })
  return http.get(`/reports/menu-publication-age?${params}`, {
    responseType: 'blob',
  })
}
